import Balancer from "react-wrap-balancer";
import Markdown from "markdown-to-jsx";
import dynamic from "next/dynamic";
import { SelfServePageData } from "../fetcher";
import type { SubscriptionLevel } from "lib/types";

const Cta = dynamic(() => import("./cta"), {
  ssr: false,
});

type HeroProps = {
  data: SelfServePageData;
  readerSubscriptionLevel: SubscriptionLevel;
  onButtonClick: () => void;
};

export const Hero = ({
  data,
  readerSubscriptionLevel,
  onButtonClick,
}: HeroProps) => {
  return (
    <>
      <div>
        <div className="mb-2 max-w-fit bg-pro-blue px-[6px] py-1">
          <p className="font-bold text-[14px] text-white ">
            {data.heroProTagText}
          </p>
        </div>
        <p className="font-recklessBold text-[32px] leading-[130%] text-pro-blue md:text-[52px] lg:text-center">
          <Balancer>{data.heroHeading}</Balancer>
        </p>

        <div className="mt-4 flex flex-col justify-between">
          <div className="lg:text-center">
            <p className="font-bold text-[18px] leading-[130%] md:text-[22px]">
              <Balancer>{data.heroSubheading}</Balancer>
            </p>
            <p className="mt-4 font-bold text-[14px] md:text-[16px] [&_del]:text-mono-40">
              <Markdown>{data.heroPriceText}</Markdown>
            </p>
            <Cta
              data={data}
              className={"mt-5 md:mt-10"}
              readerSubscriptionLevel={readerSubscriptionLevel}
              onButtonClick={onButtonClick}
            />
          </div>
        </div>
      </div>

      <div className="mt-[30px] bg-[#E3E3E5] px-3 py-4 leading-[130%] lg:mt-[70px] [&_a]:text-pro-blue [&_a]:underline [&_strong]:font-bold">
        <Markdown>{data.subscriptionSeatInfoText}</Markdown>
      </div>
    </>
  );
};
